import React, { memo, useEffect, useState } from 'react';
import { Modal } from "antd";
import { CheckCircleOutlined } from '@ant-design/icons';
import './index.less';


const SuccessModal = props => {
  const { visible = false, handleCancel, showType, wsName, msg = '操作成功!', caseNum } = props;
  const [components, setComponents] = useState(<></>);
  useEffect(() => {
    let components = <></>;
    if (showType !== '') {
      switch (showType) {
        // 立案庭
        case 'Laplsqqdz':
          components = (
            <BasicTemp>
              <div className='modalBodys'><span style={{ color: '#A42C22' }}>100个</span>已提交批量对账</div>
            </BasicTemp>
          );
          break;
        case 'Laplla':
          components = (
            <BasicTemp>
              <div className='modalBodys'>已对<span style={{ color: '#A42C22' }}>{caseNum}</span>个案件完成批量立案</div>
            </BasicTemp>
          )
          break;
        case 'Lazxahdr':
        case 'Lassahdr':
        case 'Lasbahdr':
          components = (
            <BasicTemp>
              <div className='modalBodys'>导入成功</div>
            </BasicTemp>
          )
          break;
        //审判庭
        case 'Spplpqxxlr':
          components = (
            <BasicTemp>
              <div className='modalBodys'><span style={{ color: '#A42C22' }}>100个</span>案件完成传票等文书电子邮件送达</div>
            </BasicTemp>
          )
          break;
        case 'Spplfcpwssc':
          components = (
            <BasicTemp>
              <div className='modalBodys'>文书生成成功，请仔细审核无误后送达</div>
            </BasicTemp>
          )
          break;
        case 'Spplfcpwssd':
          components = (
            <BasicTemp>
              <div className='modalBodys'><span style={{ color: '#A42C22' }}>{caseNum}</span>案件已完成送达</div>
              <div style={{ paddingLeft: 85, color: '#717171', marginTop: 7 }}>同时已自动生成以下回证:</div>
              {wsName.map((e) => {
                return (<div key={e} style={{ paddingLeft: 85, color: '#333333', marginTop: 7 }}>{e}</div>)
              })}
              <div style={{ paddingLeft: 85, color: '#717171', marginTop: 7 }}>可从各个案件对电子卷宗中查看。</div>
            </BasicTemp>
          )
          break;
        case 'Spplscbl':
          components = (
            <BasicTemp>
              <div className='modalBodys'>已对<span style={{ color: '#A42C22' }}>{caseNum}</span>个案件完成笔录生成</div>
            </BasicTemp>
          )
          break;
        case 'Spplsccpws':
          components = (
            <BasicTemp>
              <div className='modalBodys'>已对<span style={{ color: '#A42C22' }}>{caseNum}</span>个案件生成如下文书:</div>
              {wsName.map((e) => {
                return (<div key={e} style={{ paddingLeft: 85, color: '#333333', marginTop: 7 }}>{e}</div>)
              })}
              <div style={{ paddingLeft: 85, color: '#A42C22', marginTop: 7 }}>注：判决结果若非原告胜诉，请勿自动生成判决书文书。</div>
            </BasicTemp>
          )
          break;
        case 'Spplcstzsd':
          components = (
            <BasicTemp>
              <div className='modalBodys'><span style={{ color: '#A42C22' }}>{caseNum}</span>案件已完成送达</div>
              <div style={{ paddingLeft: 85, color: '#717171', marginTop: 7 }}>同时已自动生成以下回证:</div>
              {wsName.map((e) => {
                return (<div key={e} style={{ paddingLeft: 85, color: '#333333', marginTop: 7 }}>{e}</div>)
              })}
              <div style={{ paddingLeft: 85, color: '#717171', marginTop: 7 }}>可从各个案件对电子卷宗中查看。</div>
            </BasicTemp>
          )
          break;
        case 'commitArchive':
          components = (
            <BasicTemp>
              <div className='modalBodys'>已对<span style={{ color: '#A42C22' }}>{caseNum}</span>个案件完成归档</div>
            </BasicTemp>
          )
          break;
        case 'Zxplfcpwssc':
          components = (
            <BasicTemp>
              <div className='modalBodys'>文书生成成功，请仔细审核无误后送达</div>
            </BasicTemp>
          )
          break;
        case 'Zxplfcpwssd':
          components = (
            <BasicTemp>
              <div className='modalBodys'><span style={{ color: '#A42C22' }}>{caseNum}</span>案件已完成送达</div>
              {
                wsName.length > 0 && <>
                  <div style={{ paddingLeft: 85, color: '#717171', marginTop: 7 }}>同时已自动生成以下回证:</div>
                  {wsName.map((e) => {
                    return (<div key={e} style={{ paddingLeft: 85, color: '#333333', marginTop: 7 }}>{e}</div>)
                  })}
                  <div style={{ paddingLeft: 85, color: '#717171', marginTop: 7 }}>可从各个案件对电子卷宗中查看。</div>
                </>
              }
            </BasicTemp>
          )
          break;
        case 'Zxplzxjawssc':
          components = (
            <BasicTemp>
              <div className='modalBodys'>已对<span style={{ color: '#A42C22' }}>{caseNum}</span>个案件生成如下文书:
              </div>
              {wsName.map((e) => {
                return (<div key={e} style={{ paddingLeft: 85, color: '#333333', marginTop: 7 }}>{e}</div>)
              })}
            </BasicTemp>
          )
          break;
        case 'Zxpljawssd':
          components = (
            <BasicTemp>
              <div className='modalBodys'><span style={{ color: '#A42C22' }}>{caseNum}</span>案件已完成送达</div>
              {
                wsName.length > 0 && <>
                  <div style={{ paddingLeft: 85, color: '#717171', marginTop: 7 }}>同时已自动生成以下回证:</div>
                  {wsName.map((e) => {
                    return (<div key={e} style={{ paddingLeft: 85, color: '#333333', marginTop: 7 }}>{e}</div>)
                  })}
                  <div style={{ paddingLeft: 85, color: '#717171', marginTop: 7 }}>可从各个案件对电子卷宗中查看。</div>
                </>
              }
            </BasicTemp>
          )
          break;
        case 'Zxplmscdssc':
          components = (
            <BasicTemp>
              <div className='modalBodys'>已对<span style={{ color: '#A42C22' }}>{caseNum}</span>个案件生成如下文书:
              </div>
              {wsName.map((e) => {
                return (<div key={e} style={{ paddingLeft: 85, color: '#333333', marginTop: 7 }}>{e}</div>)
              })}
            </BasicTemp>
          )
          break;
        case 'Tjplscsfqrsqs':
          components = (
            <BasicTemp>
              <div className='modalBodys'>已对<span style={{ color: '#A42C22' }}>{caseNum}</span>个案件生成如下文书:</div>
              {wsName.map((e) => {
                return (<div key={e} style={{ paddingLeft: 85, color: '#333333', marginTop: 7 }}>{e}</div>)
              })}
            </BasicTemp>
          )
          break;
        case 'Spplktdj':
        case 'Sppljadj':
        case 'Zxzxpltjgd':
        case 'Zxsbpltjgd':
        case 'Zxplzdhk':
        case 'Zxplzdxg':
        case 'Zxplzdsp':
        case 'Zxplzdsx':
        case 'Djbz':
        case 'Laplfqtj':
        case 'Tjplcxtjsh':
        case 'Tjpltjsfqr':
          components = <SuccessTemp />
          break;
        default:
          components = (
            <BasicTemp>
              <div className='modalBodys'>{msg}</div>
            </BasicTemp>
          )
          break;
      }
    }
    setComponents(components);
  }, [showType, handleCancel, wsName, visible, msg, caseNum])

  return (
    <Modal
      destroyOnClose
      title={<div style={{ opacity: 0 }}>成功</div>}
      visible={visible}
      onCancel={handleCancel}
      centered
      footer={null}
    >
      {components}
    </Modal>)
};

// 操作成功的模板
const SuccessTemp = () => (
  <div className='successModal'>
    <CheckCircleOutlined className="successIcon" />
    <div className='modalBodys'>操作成功</div>
  </div>
);

// 基础模板
const BasicTemp = props => (
  <div className='successModal'>
    <CheckCircleOutlined className="successIcon" />
    {props.children}
  </div>
);

export default memo(SuccessModal)